import { SvgIcon, SvgIconProps } from '@mui/material';

export default function ArrowDropDownIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="#currentColor" />
    </SvgIcon>
  );
}
